import { Tooltip } from "@heroui/react"

const CustomTooltip = ({ ...props }) => (
  <Tooltip classNames={{ content: "bg-indigo-800 text-white" }} {...props} />
)

export { CustomTooltip }